import { render, staticRenderFns } from "./LogicArgsDialog.vue?vue&type=template&id=0594f87b&scoped=true"
import script from "./LogicArgsDialog.vue?vue&type=script&lang=js"
export * from "./LogicArgsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0594f87b",
  null
  
)

export default component.exports